import { useAtomValue } from 'jotai'
import { isNil } from 'ramda'

import type {
  Navigation,
  NavigationSignInButtonComponent,
  NavigationSignUpButtonComponent,
} from '@twisto/api-cms'

import { navigationThemeAtom } from 'homepage/components/navigation/navigation-theme'

import { SignInButton } from './sign-in-button'
import { SignUpButton } from './sign-up-button'

type Props = {
  authenticationNavigationContent: Navigation['authentication']
  source?: 'main' | 'modal'
  sort?: boolean
}
const AUTH_BTNS_COUNT = 2

const getSortedComponents = (
  components: Array<
    NavigationSignUpButtonComponent | NavigationSignInButtonComponent
  >
) => {
  if (components.length < AUTH_BTNS_COUNT) {
    return components
  }

  let signUp, signIn

  components.forEach((component) => {
    if (component.__component === 'navigation.sign-up-button') {
      signUp = component
    } else if (component.__component === 'navigation.sign-in-button') {
      signIn = component
    }
  })

  return [signUp, signIn]
}

export const AuthenticationComponents = ({
  authenticationNavigationContent,
  source,
  sort,
}: Props) => {
  const navigationTheme = useAtomValue(navigationThemeAtom)

  if (isNil(authenticationNavigationContent)) {
    return null
  }

  const components = (
    sort
      ? getSortedComponents(authenticationNavigationContent)
      : authenticationNavigationContent
  ).map((authComponentItem, index) => {
    switch (authComponentItem?.__component) {
      case 'navigation.sign-in-button':
        return (
          <SignInButton
            {...authComponentItem}
            key={index}
            inverted={navigationTheme === 'dark' && source === 'main'}
            source={source}
          />
        )
      case 'navigation.sign-up-button':
        return (
          <SignUpButton
            {...authComponentItem}
            key={index}
            variant={
              navigationTheme === 'dark' && source === 'main'
                ? 'inverted'
                : 'default'
            }
          />
        )

      default:
        return null
    }
  })

  return <>{components}</>
}
